export default "__VITE_ASSET__Cfu6CP5P__"